$(document).ready(function(){
  if($('.slick_slider_box').length > 0){
    $('.slick_slider_box').slick({
      dots: true,
      arrows: true,
      infinite: false,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      adaptiveHeight: false,
      nextArrow: '<span class="icon_slider prevarrow_custom"><svg xmlns="http://www.w3.org/2000/svg" width="9" height="18" viewBox="0 0 9 18" fill="none"><path d="M0.5 17L8.5 9L0.5 1" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/></svg></span>',
      prevArrow: '<span class="icon_slider nextarrow_custom"><svg xmlns="http://www.w3.org/2000/svg" width="9" height="18" viewBox="0 0 9 18" fill="none"><path d="M8.5 17L0.5 9L8.5 1" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/></svg></span>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });
  }

  if($('.custom_image_text_slider').length > 0){
    $('.custom_image_text_slider').slick({
      dots: true,
      infinite: true,
      arrows:true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: false,
      nextArrow: '<span class="icon_slider prevarrow_custom"><svg xmlns="http://www.w3.org/2000/svg" width="9" height="18" viewBox="0 0 9 18" fill="none"><path d="M0.5 17L8.5 9L0.5 1" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/></svg></span>',
      prevArrow: '<span class="icon_slider nextarrow_custom"><svg xmlns="http://www.w3.org/2000/svg" width="9" height="18" viewBox="0 0 9 18" fill="none"><path d="M8.5 17L0.5 9L8.5 1" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/></svg></span>'
    }); 
  }
});  